import { Injectable } from '@angular/core';
import { Geolocation, PermissionStatus } from '@capacitor/geolocation';
import { GeolocationPermission } from './geolocation-permission';
import { GeolocationStatus } from './geolocation-status';

@Injectable({
  providedIn: 'root'
})
export class GeolocationService {
  async getCurrentPosition(): Promise<GeolocationStatus.Spec> {
    try {
      const location = await Geolocation.getCurrentPosition();
      const currentPosition = new GeolocationStatus.CurrentPosition(location.coords.latitude, location.coords.longitude);

      return currentPosition;
    } catch (error) {
      return new GeolocationStatus.Error(error.message);
    }
  }

  async getPermissionsStatus(): Promise<GeolocationPermission.MSPermissionStatus> {
    try {
      const permission = await Geolocation.checkPermissions();
      const status = this.convertPermissionStatus(permission);

      return status;
    } catch (error) {
      return GeolocationPermission.MSPermissionStatus.DISABLE;
    }
  }

  async requestPermission(): Promise<GeolocationPermission.MSPermissionStatus> {
    try {
      const permission = await Geolocation.requestPermissions();
      const status = this.convertPermissionStatus(permission);

      return status;
    } catch (error) {
      return GeolocationPermission.MSPermissionStatus.DISABLE;
    }
  }

  private convertPermissionStatus(permission: PermissionStatus): GeolocationPermission.MSPermissionStatus {
    const locationStatus = GeolocationPermission.convertPermissionStatus(permission.location);
    const coarseLocationStatus = GeolocationPermission.convertPermissionStatus(permission.coarseLocation);
    const status = GeolocationPermission.getGreaterPermissionStatus(locationStatus, coarseLocationStatus);

    return status;
  }
}
